<template>
    <div id="lock">
        <el-table empty-text="Geen leerling gevonden..." v-loading.body="loading" element-loading-text="Laden..." :stripe=true :border=true :data="student">
    
            <el-table-column label="IDNR" prop="tbl_student.governement_id">
            </el-table-column>
            <el-table-column label="Voornaam" prop="tbl_student.firstname">
            </el-table-column>
            <el-table-column label="Achternam" prop="tbl_student.surname">
            </el-table-column>
            <el-table-column label="Geslacht" prop="tbl_student.tbl_sys_gender.name">
            </el-table-column>    
            <el-table-column label="Leerling #" prop="student_number">
                <template slot-scope="scope">
                    <el-input size="small" v-model="student_number" @blur="student_number_save(scope.row.id,this.value)"></el-input>
                </template>
            </el-table-column>
    
        </el-table>
    </div>
</template>

<script>
import Axios from 'axios'
//import Icon from 'vue-awesome/components/Icon.vue'
import {
    API_ROOT
} from '../config'
var instance = Axios.create({
    baseURL: API_ROOT,
    timeout: 60000

});


export default {
    name: 'lock',
    created: function () {
        //this.getUnits()
        // if (_.isUndefined(this.user.data)) {
        //     this.$router.push({
        //         path: '/'
        //     });
        // }
        // this.getRoles();
        this.fetch_student();



    },

    data: function () {
        return {
            student: {
                id: '',
                schoolyear_id: '',
                school_id: '',
                class_id: '',
                tbl_conf_class: {
                    id: "",
                    school_id: "",
                    grade_id: "",
                    tbl_grade: {
                        id: "",
                        grade: "",
                        description: ""
                    },
                    name: "",
                    testgroup: ""
                },
                student_id: '',
                language_id: '',
                student_number: '',
                registration_date: '',
                last_school: '',
                tbl_student: {
                    id: '',
                    governement_id: '',
                    surname: '',
                    firstname: '',
                    preposition: '',
                    nickname: '',
                    gender_id: '',
                    birthdate: '',
                    birthplace_id: '',
                    denomination_id: '',
                    native_language_id: '',
                    address: '',
                    neighborhood: '',
                    telephone: '',
                    nationality_id: '',
                    telephone_owner: '',
                    email: '',
                    visually_impaired: false,
                    tbl_studen_marks: [],
                    tbl_student_learning_disabilties: [],
                    tbl_student_miscellaneous_marks: [],
                    tbl_further_education: {
                        "id": 0,
                        "student_id": 0,
                        "director_advice": "",
                        "justification": "",
                        "sys_havo_id_1": 0,
                        "sys_havo_id_2": 0,
                        "sys_havo_id_3": 0,
                        "sys_vsbo_id_1": 0,
                        "sys_vsbo_id_2": 0,
                        "sys_vsbo_id_3": 0,
                        "objection_advice": false,
                        "appeal_result": false,
                        "particularies": ""
                    }
                },
                tbl_school: {
                    id: '0',
                    schoolboard_id: '',
                    name: ' ',
                    address: '',
                    telephone: '',
                    fax: '',
                    email: '',
                    webpage: '',
                    d_name: '',
                    d_address: '',
                    d_telephone: '',
                    d_fax: '',
                    d_email: '',
                    w_name: '',
                    w_address: '',
                    w_telehpone: '',
                    w_fax: '',
                    w_email: '',
                    schoolnumber: '',
                    schooltype_id: '',
                    createdAt: '',
                    updatedAt: ''
                }
            },
            loading: true
        }
    },
    watch: {
        tbl_student() {
            console.log(this.student);
            if (this.student.id != '') {
                this.fetch_marks(this.student.student_id);



                return this.student.tbl_student
            } else {
                return {
                    id: '',
                    governement_id: '',
                    surname: '',
                    firstname: '',
                    preposition: '',
                    nickname: '',
                    gender_id: '',
                    birthdate: '',
                    birthplace_id: '',
                    denomination_id: '',
                    native_language_id: '',
                    address: '',
                    neighborhood: '',
                    telephone: '',
                    nationality_id: '',
                    telephone_owner: '',
                    email: '',
                    visually_impaired: ''
                }

            }
        },
        tbl_conf_class() {
            if (!_.isUndefined(this.student)) {
                return this.student.tbl_conf_class
            } else {
                return {
                    id: "",
                    school_id: "",
                    grade_id: "",
                    tbl_grade: {
                        id: "",
                        grade: "",
                        description: ""
                    },
                    name: "",
                    testgroup: ""
                }

            }
        },
        tbl_school() {
            if (!_.isUndefined(this.student)) {
                return this.student.tbl_school
            } else {
                return {
                    id: '0',
                    schoolboard_id: '',
                    name: ' ',
                    address: '',
                    telephone: '',
                    fax: '',
                    email: '',
                    webpage: '',
                    d_name: '',
                    d_address: '',
                    d_telephone: '',
                    d_fax: '',
                    d_email: '',
                    w_name: '',
                    w_address: '',
                    w_telehpone: '',
                    w_fax: '',
                    w_email: '',
                    schoolnumber: '',
                    schooltype_id: '',
                    createdAt: '',
                    updatedAt: ''
                }

            }
        }

    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        loggedin() {
            return this.$store.getters.getLoggedin;
        }
    },
    methods: {
        fetch_student() {
            var self = this
            //instance.get('/student-class/' + this.$route.params.id).then(function (response) {
                instance.get('/student-class/1').then(function (response) {
                var stud = response.data.data;
                _.merge(self.student, response.data.data);
                console.log('Student object fetched...');
                console.log(self.student)

                self.loading = false;


            });
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
        flClick(id, value) {
            instance.post('/user/set-firstlogin', {
                id: id,
                firstlogin: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },
        slClick(id, value) {
            instance.post('/user/set-lockedsystem', {
                id: id,
                locked_system: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },
        role_save(id, value) {
            instance.post('/userrol-update', {
                id: id,
                role_id: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },
        student_number_save(id, value) {
            instance.post('/student/studentnumber', {
                id: id,
                student_number: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },        
        getUsers: function () {
            var self = this;
            //console.log(this.selected_class);
            this.params = this.$route.params;
            console.log(this.$route);

            instance.get('/user').then(function (response) {


                _.merge(self.Users, response.data.data);

                for (var i = 0; i < self.Users.length; i++) {

                    var role = self.Users[i].tbl_sys_userrols[0];
                    console.log(i);
                    console.log(role);

                    self.selected_firstlogin.push(self.Users[i].firstlogin);
                    self.selected_locked.push(self.Users[i].locked_system);
                    if (role) {
                        self.selected_roles.push(role.role_id);
                    }

                }
                self.loading = false;
                console.log(self.selected_roles);

            });

        },
        getRoles: function () {
            var self = this;
            //console.log(this.selected_class);
            this.params = this.$route.params;
            console.log(this.$route);

            instance.get('/role').then(function (response) {

                console.log(response.data.data);
                console.log(self.Roles);
                _.merge(self.Roles, response.data.data);

                self.getUsers();




            });

        }
    }
}
</script>
<style scoped>
.layout {
    height: 540px;
    overflow-y: scroll;
    ;
    z-index: 1;
}

.text {
    font-size: 10px;
}

body {
    margin-top: 30px;
    margin-right: 250px;
    margin-left: 250px;
    margin-bottom: 60px;
}
</style>
